<template>
  <Layout>
    <PageHeader :items="items" :title="title"/>

    <div class="row">
      <div class="col-md-12">
        <b-card>
          <div v-if="Object.keys(trainee_name).length !== 0" class="form-row" style="margin-top: -15px;margin-bottom: 10px;">
            <div class="col-md-6">
              <h6 class="page-title font-18">:: {{ trainee_name }} ::</h6>
            </div>
            <div class="col-md-6">
              <router-link :to="{ name: 'traineeDocumentTrackingPrintView', params: { trainee_id: trainee_id } }"
                           class="action-icon" tag="a"
                           target="_blank" title="Trainee File Print View">View File Tracking
              </router-link>
            </div>
          </div>

          <form action="">
            <div>
              <table class="table table-centered table-striped">
                <thead>
                <tr>
                  <th>Sl</th>
                  <th>Category</th>
                  <th>Sub Category</th>
                  <th>File</th>
                  <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(file_tracking, index) in file_trackings" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{file_tracking.doc_category.desc}}</td>
                  <td>{{file_tracking.desc}}</td>
                  <td>
                    <span v-if="file_tracking.trainee_doc">
                      <a :href="file_tracking.trainee_doc.name" target="_blank">
                        <img :src="file_tracking.trainee_doc.name" alt="" class="rounded-circle" height="30px" width="30px"/>
                      </a>
                    </span>
                  </td>
                  <td>
                    <span v-if="file_tracking.trainee_doc">
                       Uploaded
                    </span>
                    <span v-else>
                       Pending
                    </span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </form>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

export default {
  page: {
    title: "File Tracking",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader},
  data() {
    return {
      title: "File Tracking",
      items: [
        {
          text: "trainee",
          href: "trainee/files"
        },
        {
          text: "Dashboard",
          active: true
        }
      ],
      trainee_id: "",
      trainee_name: "",
      file_trackings: [],
      validation_errors: {},
      show: false
    };
  },
  mounted() {
    this.trainee_id = this.$route.params.trainee_id;
    this.getFileTracking();
    this.getTrainee();
  },
  methods: {
    getFileTracking() {
      let trainee_id = this.$route.params.trainee_id;
      http
          .get("api/trainee/getFiles/" + trainee_id)
          .then(response => {
            this.ses = response.data.ses;
            this.file_trackings = response.data.file_trackings;
          })
          .catch();
    },
    getTrainee() {
      let trainee_id = this.$route.params.trainee_id;

      http.get("api/trainee/" + trainee_id).then(response => {
        if (!response.data.error) {
          this.trainee_name = response.data.trainee_name;
        }
      });
    },
  },


};
</script>
<style>

</style>
